import { FC } from 'react';
import styles from './styles.module.scss';
import TransactionItem from './transaction_item';
import Typography from '@components/common/typography';
import { TTransaction, TTransactionLite } from '@xeppt/xeppt-sdk/types';
import Skeleton from '@components/common/skeleton';
import illustration from '@svg/illustrations/empty_transaction.svg';
import illustrationRequests from '@svg/illustrations/empty_requests.svg';
import { TPaymentIntent } from '@xeppt/xeppt-sdk/types/payment-intent';

interface IProps {
    transactions?: TTransactionLite[] | TPaymentIntent[];
    isTransactionsLoading?: boolean;
    activeTab?: string;
    isCard?: boolean;
    isSale?: boolean;
    transactionProvided?: boolean;
    refetchTransactions?: () => void;
    onTransactionClick?: (transaction: TTransaction) => void;
}

const TransactionTable: FC<IProps> = ({
    transactions,
    isTransactionsLoading,
    activeTab,
    isSale,
    transactionProvided = false,
    refetchTransactions,
    isCard,
    onTransactionClick
}) => {
    return (
        <div className={styles.wrapper}>
            {transactions?.length === 0 && !isTransactionsLoading ? (
                <div className={styles.empty_transactions}>
                    <img
                        src={activeTab === 'transactions' ? illustration : illustrationRequests}
                        alt="illustration"
                    />
                    <Typography variant="body3" className={styles.title}>
                        No {activeTab === 'transactions' ? 'transactions' : 'requests'} yet
                    </Typography>
                    <div className={styles.description}>
                        {activeTab === 'transactions'
                            ? ' All transactions made will be listed here'
                            : 'All requests sent and received will be listed here'}
                    </div>
                </div>
            ) : (
                <>
                    {transactions?.map((item, i) => {
                        return (
                            <TransactionItem
                                key={i}
                                transactionProvided={transactionProvided}
                                refetchTransactions={refetchTransactions}
                                transaction={item as TTransactionLite}
                                isCard={isCard}
                                isSale={isSale}
                                onTransactionClick={onTransactionClick}
                            />
                        );
                    })}
                    {isTransactionsLoading && (
                        <>
                            <Skeleton className={styles.skeleton} />
                            <Skeleton className={styles.skeleton} />
                            <Skeleton className={styles.skeleton} />
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default TransactionTable;
